/* eslint-disable max-len */
import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ChevronUpIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.50508 17.1696C3.82501 17.4877 4.25778 17.6662 4.70889 17.6662C5.15999 17.6662 5.59276 17.4877 5.91269 17.1696L12.0427 11.125L18.0873 17.1696C18.4072 17.4877 18.84 17.6662 19.2911 17.6662C19.7422 17.6662 20.175 17.4877 20.4949 17.1696C20.655 17.0109 20.782 16.8221 20.8687 16.614C20.9554 16.4059 21 16.1827 21 15.9573C21 15.7319 20.9554 15.5087 20.8687 15.3006C20.782 15.0926 20.655 14.9037 20.4949 14.745L13.255 7.50508C13.0963 7.34504 12.9074 7.21801 12.6994 7.13132C12.4913 7.04463 12.2681 7 12.0427 7C11.8173 7 11.5941 7.04463 11.386 7.13132C11.1779 7.21801 10.9891 7.34504 10.8303 7.50508L3.50508 14.745C3.34504 14.9037 3.21801 15.0926 3.13132 15.3006C3.04463 15.5087 3 15.7319 3 15.9573C3 16.1827 3.04463 16.4059 3.13132 16.614C3.21801 16.8221 3.34504 17.0109 3.50508 17.1696Z" fill="currentColor" />
        </SvgIcon>
    );
};

export default ChevronUpIcon;
